import React, { useEffect, useState } from "react";
import { CheckCircle2, AlertCircle, Circle, Activity } from "lucide-react";
import { Link } from "react-router-dom";
import { getCoachingDashboardToday } from "../../lib/api";

function fmtAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const ms = Date.now() - d.getTime();
  const h = Math.floor(ms / 3600000);
  if (h < 1) return "Just now";
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function CoachActivityWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    getCoachingDashboardToday()
      .then(setData)
      .catch(() => setData({ complete: 0, partial: 0, skipped: 0, recent: [] }));
  }, []);

  if (!data) {
    return (
      <div className="text-xs text-[var(--tir-muted)] py-4">Loading recent activity…</div>
    );
  }
  const total = data.complete + data.partial + data.skipped;
  if (total === 0) {
    return null;
  }

  return (
    <section className="mb-10 border border-[var(--tir-border)] bg-white p-6" data-testid="coach-activity-widget">
      <div className="flex items-baseline justify-between mb-4">
        <div>
          <div className="text-[10px] tracking-[0.26em] uppercase font-semibold text-[var(--tir-burgundy)] flex items-center gap-2">
            <Activity size={12} /> Athlete activity · last 7 days
          </div>
          <h2 className="font-serif-display text-2xl mt-1">{total} workouts logged</h2>
        </div>
        <div className="flex items-center gap-4 text-[11px] tracking-[0.18em] uppercase font-semibold">
          <span className="flex items-center gap-1.5 text-emerald-700">
            <CheckCircle2 size={12} /> {data.complete} complete
          </span>
          <span className="flex items-center gap-1.5 text-amber-600">
            <AlertCircle size={12} /> {data.partial} partial
          </span>
          <span className="flex items-center gap-1.5 text-[var(--tir-burgundy)]">
            <Circle size={12} /> {data.skipped} missed
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        {data.recent.slice(0, 6).map((log) => (
          <Link
            key={log.id}
            to={`/coaching/athletes/${log.coaching_athlete_id}`}
            className="flex items-center gap-3 p-2 hover:bg-[var(--tir-ivory)] transition-colors border-l-2"
            style={{
              borderLeftColor:
                log.status === "complete" ? "#2F855A" :
                log.status === "partial" ? "#D69E2E" : "#7A1F2B",
            }}
          >
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-[var(--tir-ink)] truncate">
                {log.athlete_name}
              </div>
              <div className="text-[11px] text-[var(--tir-muted)] truncate">
                {log.workout_title || "Workout"} · W{log.week_number} · {log.day_label}
              </div>
            </div>
            <span className="text-[10px] tracking-[0.18em] uppercase text-[var(--tir-muted)] whitespace-nowrap">
              {fmtAgo(log.updated_at)}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
